export default __webpack_public_path__ + "static/Payment-Gateways-4b4f4ea23d4d03acb4c1c4534b8338dd.webp";